export const NETWORK_STATUS_ERRORS = {
  PROVIDER_MISSING: 'useNetworkStatus must be used within a NetworkStatusProvider',
  CONNECTION_ERROR: 'Failed to determine network status'
} as const;
